export interface ReleaseNote {
  version: string;
  date: string;
  changes: string[];
}

export const releaseNotes: ReleaseNote[] = [
  {
    version: '1.24.4',
    date: '2026-05-18',
    changes: ['Google 検索への表示改善のため、内部的なSEO設定を最適化しました'],
  },
  {
    version: '1.24.3',
    date: '2026-05-18',
    changes: [
      'プッシュ通知をオフにしている場合でも、週次ランキング更新の通知が通知画面に届くよう修正しました',
    ],
  },
  {
    version: '1.24.2',
    date: '2026-05-14',
    changes: [
      'スポットをSNSでシェアしたときに、スポットの写真・名前・説明が正しく表示されるよう修正しました',
    ],
  },
  {
    version: '1.24.1',
    date: '2026-05-14',
    changes: ['Google 検索からサイトが見つかりやすくなるよう、内部の SEO 設定を改善しました'],
  },
  {
    version: '1.24.0',
    date: '2026-05-13',
    changes: [
      'ダイレクトメッセージの会話画面から、相手をブロック・ブロック解除できるようになりました',
      'ブロック中のユーザーとの会話はDMリストに表示されなくなりました',
      '通知設定画面からブロックリストを管理できるようになりました。ブロック中のユーザーの確認・解除が一覧でできます',
      '通知を開いたときに既読バッジがすぐ消えない問題を修正しました',
    ],
  },
  {
    version: '1.23.1',
    date: '2026-05-11',
    changes: [
      'よくある質問・使い方ガイドのSEO情報が正しく検索エンジンに認識されるよう修正しました',
    ],
  },
  {
    version: '1.23.0',
    date: '2026-05-11',
    changes: [
      'ダイレクトメッセージで「現在地を送る」ボタンが追加されました。相手には地図カードとして届き、タップするとGoogleマップで自転車ルートのナビが起動します',
      'ダイレクトメッセージのスレッドを開いたとき、最新のメッセージが自動的に表示されるようになりました',
      'ダイレクトメッセージを受信したとき、通知画面にも表示されるようになりました',
      'マップの天気ポップアップがiPhone 7などの端末で「現在地」ボタンの下に隠れてしまう問題を修正しました',
      'ダイレクトメッセージと通知は90日間保存されます。古くなったメッセージ・通知は自動的に削除されます',
      '使い方ガイドとよくある質問にダイレクトメッセージの説明を追加しました',
    ],
  },
  {
    version: '1.22.0',
    date: '2026-05-08',
    changes: [
      'マップの天気バッジのポップアップで、気温・風の情報を天気名の横に横並びで表示するようにしました',
      'マップの「現在地」ボタンのラベルを「現在地に移動」に変更しました',
      'アプリ起動時のスプラッシュ画面の背景色を白に変更しました',
    ],
  },
  {
    version: '1.21.1',
    date: '2026-05-07',
    changes: [
      'マップの天気バッジの時間予報に風速（km/h）が表示されない問題を修正しました',
      'マップの天気バッジの時間予報が折り返して表示される問題を修正しました',
    ],
  },
  {
    version: '1.21.0',
    date: '2026-05-06',
    changes: [
      'マップ画面に地名・住所検索ができる検索ボックスを追加しました。右上の虫眼鏡アイコンをタップして地名や住所を入力すると、その場所にマップが移動します',
      '検索ボックスと天気バッジを右上に横並び表示するようにしました',
      '読み込み中のバナーが検索ボックスに隠れないよう表示位置を調整しました',
      'ホーム画面追加時のスプラッシュ画面の背景色をブランドカラーに統一しました',
    ],
  },
  {
    version: '1.20.0',
    date: '2026-05-06',
    changes: [
      '通知設定を専用画面（アカウント→通知設定）に移動しました',
      'ホーム画面アイコンのデザインを改善しました（背景色付き・文字なし）',
      '天気予報の時間ごと予報に風速（km/h）を表示するようにしました',
      'アプリ内のロゴからテキストを削除し、グラフィックのみに変更しました',
    ],
  },
  {
    version: '1.19.0',
    date: '2026-05-06',
    changes: [
      '自分が登録したスポットに他のユーザーがコメントしたときに通知が届くようになりました',
      '通知設定に「自分のスポットへのコメント」のON/OFFトグルを追加しました',
    ],
  },
  {
    version: '1.18.1',
    date: '2026-05-05',
    changes: [
      'スポット詳細の説明文で改行が正しく表示されるようになりました',
      'マップ画面を開いたときに現在地の取得が自動で始まるようになりました',
    ],
  },
  {
    version: '1.18.0',
    date: '2026-05-03',
    changes: [
      'スポット詳細画面に「現地の天気」セクションを追加しました。スポットの座標をもとに現地の天気・気温・体感温度・風を確認できます',
      'スポット詳細の天気はデフォルト折りたたみ表示で、タップすると8時間予報に展開できます',
      'マップの天気バッジもタップで8時間予報が確認できるようになりました（従来は5時間）',
      '天気バッジの展開パネルのデザインを改善し、天気名・体感温度を予報欄に追加しました',
    ],
  },
  {
    version: '1.17.0',
    date: '2026-05-03',
    changes: [
      'マップ画面の上部に天気ストリップを追加しました。現在地の天気・気温・降水確率・風向き・風速が一目で確認できます',
      '天気は現在 + 次5時間の予報を横スクロールで表示します',
      '現在地ボタンを押したとき、天気情報も最新に更新されるようになりました',
      '天気欄・マップ・ナビバーを明確に分離し、マップに表示されるスポット数が正確になりました',
      'ブックマークしたスポットに新しいコメントや写真が投稿されたときに通知が届くようになりました',
      'プロフィールの通知設定に「ブックマーク新着」トグルを追加しました',
      'ランディングページのデザインを改善しました',
    ],
  },
  {
    version: '1.16.0',
    date: '2026-05-02',
    changes: [
      'スポットをシェアするときに、評価・チェックイン回数も一緒に共有されるようになりました',
      'プロフィール画面のフォロワー数・フォロー中数の表示を見やすくしました',
      'マップでスポットをタップしたとき、ポップアップがちらつく問題を修正しました',
      'タイムライン・ランキング・プロフィール画面を開いたとき、一番上から表示されない問題を修正しました',
      'ランキング画面にトップ3の表彰台デザインを追加しました',
      'スポット一覧にカテゴリのアクセントを追加しました',
      'タイムラインに縦ボーダーを追加してアクティビティを見やすくしました',
      'チェックインボタンのアイコンを大きくしました',
      'ナビゲーションのリンクを改善し、iOSでも自転車ルートが選択されやすくなりました',
    ],
  },
  {
    version: '1.15.2',
    date: '2026-04-30',
    changes: [
      '「使い方ガイド」「よくある質問」「紹介ページ」がGoogle検索に表示されやすくなりました',
    ],
  },
  {
    version: '1.15.1',
    date: '2026-04-29',
    changes: ['セキュリティを強化しました'],
  },
  {
    version: '1.15.0',
    date: '2026-04-29',
    changes: [
      'スポットをブックマークに保存できるようになりました（スポット詳細画面のブックマークボタン）',
      'プロフィール画面からブックマーク一覧を確認できるようになりました',
      '他のユーザーをフォローできるようになりました',
      'タイムラインに「フォロー中」タブが追加され、フォローしているユーザーの活動だけを絞り込んで見られるようになりました',
      'プロフィール画面にフォロワー数・フォロー中数が表示されるようになりました',
      'コメント返信通知・ランキング更新通知のON/OFFを個別に設定できるようになりました',
      'ページを移動したときに画面が先頭から表示されるようになりました',
      'スポット一覧の統計アイコン（チェックイン・いいね・距離）をSVGに統一し、どの端末でも同じ見た目になりました',
      'アプリ全体のデザインを統一しました（カラー・ナビゲーション・タグ・ローディング表示など）',
    ],
  },
  {
    version: '1.14.1',
    date: '2026-04-28',
    changes: [
      'よくある質問ページが検索結果に展開表示されやすくなりました',
      'ランディングページの読み込み速度を改善しました',
    ],
  },
  {
    version: '1.14.0',
    date: '2026-04-28',
    changes: [
      'コメントへの返信ができるようになりました（スレッド表示）',
      'コメント返信が届いたときにプッシュ通知が届くようになりました（通知を許可している場合・Android対応）',
      'プロフィール画面にベルアイコンが追加され、未読通知数が一目でわかるようになりました',
      '通知をタップすると対象のコメントまで自動的にスクロールし、ハイライト表示されるようになりました',
      'コメントを削除する前に確認ダイアログが表示されるようになりました',
      'コメントの投稿日時に時刻が表示されるようになりました',
      'プロフィール画面のデザインを改善しました（セクション見出し・バッジ表示の調整）',
    ],
  },
  {
    version: '1.13.3',
    date: '2026-04-26',
    changes: [
      'マップ画面のスポット一覧・現在地ボタンがアドレスバーの表示・非表示に連動してズレる問題を恒久修正しました',
      'マップ画面でアドレスバー操作時にLeafletのズームボタンが画面上部に隠れる問題を修正しました',
      'アプリ更新通知がマップ画面のボタンの裏に隠れる問題を修正しました',
    ],
  },
  {
    version: '1.13.2',
    date: '2026-04-25',
    changes: [
      '使い方ガイドの説明文を最新のUI操作に合わせて修正しました',
      '使い方ガイドのスクリーンショットを最新UIに差し替えました',
      'FAQのスポット登録・写真削除に関する説明を現在の操作方法に合わせて修正しました',
    ],
  },
  {
    version: '1.13.1',
    date: '2026-04-25',
    changes: ['いいねボタンの「いいね済み」表示を「いいね済」に修正しました'],
  },
  {
    version: '1.13.0',
    date: '2026-04-25',
    changes: [
      'チェックインバッジのデザインを刷新しました（ライト背景＋ロードバイクアイコン＋弧状の星でランクを表現）',
      'スポットメイカーバッジのデザインを刷新しました（山岳シルエット＋シェブロン数でランクを表現するシールド型に変更）',
      'ランキングページの初期表示を「週間ランキング」に変更しました',
      'ランキングページの「チェックイン」「スポット登録」切り替えボタンが均等幅で表示されるようになりました',
    ],
  },
  {
    version: '1.12.0',
    date: '2026-04-25',
    changes: [
      'スポット詳細に戻るボタンを追加しました（LINEなど外部リンクからのアクセス時は「マップに戻る」として動作します）',
      'スポット詳細のヘッダーがスクロールしても常に固定表示されるようになりました',
      'スポット登録フォームで現在地の住所が自動表示されるようになりました（座標ではなく地名で確認できます）',
      '現在地がマップの表示範囲外のとき「現在地を登録」ボタンがグレーアウトし、理由を通知するようになりました',
      '削除・操作の確認ダイアログをアプリのデザインに統一しました（ブラウザ標準のポップアップを廃止）',
      'ログインしていない状態でいいねボタンをタップすると「ログインするといいねできます」と案内が表示されるようになりました',
      'プロフィール画面にログアウトボタンを追加しました',
      'アカウント削除を専用の「危険な操作」セクションとしてページ最下部に分離しました',
    ],
  },
  {
    version: '1.11.0',
    date: '2026-04-23',
    changes: [
      'スポットメイカーランクのバッジを新デザインに変更しました（Lv1〜Lv5それぞれに専用のシールド型SVGデザインを採用）',
      'プロフィール画面でバッジをタップすると画面中央に大きく拡大表示されるようになりました',
      '/helpページがGoogleにインデックス登録されない問題を修正しました',
    ],
  },
  {
    version: '1.10.0',
    date: '2026-04-22',
    changes: [
      'プロフィール画面のランクバッジをアイコン・氏名欄の右に大きく表示するようにしました（タップするとランク名が表示されます）',
      'マップ画面でiOSのアドレスバー表示・非表示時にボタンが隠れる問題を修正しました',
      'セキュリティ強化：データベースの全テーブルに行レベルセキュリティ（RLS）を有効化しました',
      'ランディングページで更新通知を非表示にしました',
    ],
  },
  {
    version: '1.9.0',
    date: '2026-04-21',
    changes: [
      '週間・月間・年間ランキングを「前期間の確定結果」方式に変更しました（期間終了後に自動集計され、ランキング画面に集計期間が表示されます）',
      'ランキング画面に集計期間のラベルを表示するようにしました',
      '管理画面からランキングスナップショットを手動生成できるようになりました',
    ],
  },
  {
    version: '1.8.0',
    date: '2026-04-21',
    changes: [
      'スポット詳細にシェアボタンを追加しました（SNSへのリンク共有時にスポット名・写真付きのプレビューが表示されます）',
      'スポットのメイン写真を設定できるようになりました（設定した写真はマップのマーカーやSNSシェア時に使われます）',
      '写真の操作（メイン設定・削除・通報）を写真タップ後のライトボックス画面に移動しました',
    ],
  },
  {
    version: '1.7.0',
    date: '2026-04-20',
    changes: [
      'プロフィールに活動エリアを追加しました（都道府県を地方グループ別に複数選択できます）',
      '現在地がマップの表示範囲外にある時は「現在地を登録」ボタンを非表示にしました',
    ],
  },
  {
    version: '1.6.1',
    date: '2026-04-19',
    changes: [
      'マップのスポット一覧ボタンに現在の表示件数を表示するようにしました',
      '現在地が取得できていないときは「現在地を登録」ボタンを非表示にしました',
    ],
  },
  {
    version: '1.6.0',
    date: '2026-04-19',
    changes: [
      'プロフィールにギア紹介を追加しました（フレーム・コンポ・ホイール・タイヤなど11項目）',
      'プロフィールに走行スタイルを追加しました（9つの選択肢から複数選択可能）',
      '月間走行距離を5段階から選べるようになりました',
      'タイムラインで投稿日時が上部に表示されるようになりました',
      'アプリ更新通知が正しく表示されるようになりました',
    ],
  },
  {
    version: '1.5.3',
    date: '2026-04-19',
    changes: [
      'スポット詳細の写真をタップすると全画面で表示されるようになりました（左右スワイプで前後の写真へ移動できます）',
      '写真をアップロードすると、リロードしなくてもすぐに表示されるようになりました',
      'アプリをしばらく使わなかった後に操作してもエラーが出なくなりました（認証トークンの自動更新に対応）',
      'プロフィール画面で「ユーザーが見つかりません」と表示される問題を修正しました',
    ],
  },
  {
    version: '1.5.2',
    date: '2026-04-18',
    changes: [
      'ボトムナビを4タブに整理しました（マップ・タイムライン・ランキング・プロフィール）',
      'スポット一覧・現在地を登録ボタンをマップ画面下部に集約しました',
      'マップ下部ボタンを横並びに変更しました（スポット一覧・現在地を登録・現在地）',
      'FAQページをカテゴリアイコン・Q/Aバッジ付きのデザインに刷新しました',
    ],
  },
  {
    version: '1.5.1',
    date: '2026-04-17',
    changes: [
      'ボトムナビの順序を変更しました（スポット一覧→スポット登録→タイムライン→ランキング→プロフィール）',
      'ボトムナビのラベルを「スポット一覧」「スポット登録」に変更しました',
      'タイムラインの保持期間を管理コンソールから設定できるようにしました（デフォルト: 90日）',
    ],
  },
  {
    version: '1.5.0',
    date: '2026-04-17',
    changes: [
      'タイムライン機能を追加しました（ボトムナビの新しいタブから全ユーザーのアクティビティを確認できます）',
      'チェックイン・スポット登録・写真投稿がタイムラインに表示されるようになりました',
      'タイムラインは無限スクロールで過去のアクティビティを遡れます',
    ],
  },
  {
    version: '1.4.0',
    date: '2026-04-17',
    changes: [
      'よくある質問（FAQ）ページを追加しました（プロフィール画面・ランディングページからアクセスできます）',
    ],
  },
  {
    version: '1.3.0',
    date: '2026-04-16',
    changes: [
      '自分がアップロードした写真を削除できるようになりました（写真にホバーで削除ボタンが表示されます）',
    ],
  },
  {
    version: '1.2.0',
    date: '2026-04-16',
    changes: [
      '通報機能を追加（スポット・コメント・写真を通報できます）',
      'ランキングのユーザー名をタップしてプロフィールへ遷移できるようになりました',
    ],
  },
  {
    version: '1.1.0',
    date: '2026-04-16',
    changes: ['スポット編集機能を追加（登録者が名前・説明・住所・カテゴリ・タグを変更できます）'],
  },
  {
    version: '1.0.0',
    date: '2026-04-14',
    changes: [
      '本番環境を正式公開（ridehub.shiget.net）',
      'ステージング環境との完全分離（DB・Firebase・Storage）',
      'Google Analytics によるアクセス計測を導入',
    ],
  },
  {
    version: '0.3.0',
    date: '2026-04-05',
    changes: [
      'プロフィールにアイコン画像を設定できるようになりました',
      '愛車紹介機能を追加（愛車名・説明・写真を登録できます）',
      'ランディングページ（/landing）を追加',
      'マップのスポットアイコンをクラスター表示から個別表示に改善',
    ],
  },
  {
    version: '0.2.0',
    date: '2026-04-04',
    changes: [
      'プロフィール画面をiOS Settings風カードUIにリニューアル',
      'チェックイン一覧・登録スポット一覧画面を追加',
      'マーカークラスタリングで近接スポットをグループ表示',
      '使い方ガイドページを追加（スクリーンショット付き）',
      'リリースノートページを追加',
      'アプリ情報セクション（バージョン・開発者・フィードバック）を追加',
    ],
  },
  {
    version: '0.1.0',
    date: '2026-04-04',
    changes: [
      'マップ表示範囲でスポット検索',
      'スポット一覧にタグ表示',
      'スポット詳細画面をタブUI（写真/チェックイン/コメント）にリニューアル',
      'カテゴリとタグを固定選択式に再設計',
      'チェックインランクを星スコア表示に変更',
      '初回リリース',
    ],
  },
];
